<template>
    <div>
        <h4 class="font-weight-light"> Habilidades</h4>
<!--        <li class="list-unstyled" v-for="(item, key) in user.skill" :key="key">-->
<!--            {{item.habilidad}}-->
<!--            <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>-->
<!--        </li>-->
      <ul class="list-unstyled" v-if="user">
        <li v-for="(item, key) in user.skill" :key="key">
          {{item.habilidad}}
          <ol v-if="item.file">
               <a class="text-kllaar" target="_blank" :href="item.file">
                  <i class="fas fa-paperclip text-primary"></i> 
                    Evidencia
                </a>
            <!-- <button class="btn btn-sm b-transparent text-kllaar"
                    @click="openFile(item.file)">
              <i class="fas fa-paperclip text-primary"></i> Evidencia
            </button> -->
          </ol>
        </li>
<!--        <li v-for="(item, key) in user.service" :key="key">-->
<!--          {{item.organizacion}}-->
<!--          <ol>{{item.empresa}}</ol>-->
<!--          <ol>Función {{item.funcion_desempenada}}</ol>-->
<!--          <ol>{{item.ano_inicio + ' - ' + item.ano_fin}}</ol>-->
<!--          <ol>{{item.descripcion}}</ol>-->
<!--          <ol v-if="item.file"><button class="btn btn-sm b-transparent" @click="openFile(item.file)"><i class="fas fa-paperclip"></i> Evidencia</button></ol>-->
<!--        </li>-->
      </ul>
    </div>
</template>
<script>
export default {
    props:{
        user :Object,
        isGold: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {

        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/student_profile/elements/Skill.vue